import PropTypes from 'prop-types';
import React from 'react';

import { VisuallyHidden } from 'common/styles/oc-styled-components';
import {
  getFullDayOfTheWeek,
  getHoursForScreenReader,
  getHoursToDisplay,
} from 'pages/common/helpers/appointment-slot-helpers';

import { Hours, HoursList, Row, WeekDay } from './styled-components';

const ClinicHoursList = ({ hours }) => {
  // Start schedule at Monday
  const todayIndex = 1;
  const weekDays = [...Array(7).keys()];
  const arrangedHours = hours
    .slice(todayIndex, hours.length)
    .concat(hours.slice(0, todayIndex));
  const arrangedWeekDayOrder = weekDays
    .slice(todayIndex, weekDays.length)
    .concat(weekDays.slice(0, todayIndex));

  return (
    <HoursList>
      {hours
        && arrangedHours.map((hour, i) => {
          const day = getFullDayOfTheWeek(arrangedWeekDayOrder[i]);
          const HoursToDisplay = getHoursToDisplay(hour.start, hour.end);
          const isClosed = HoursToDisplay === 'Closed';

          return (
            <Row aria-hidden key={day}>
              <VisuallyHidden>
                {`${getFullDayOfTheWeek(arrangedWeekDayOrder[i])},
              ${getHoursForScreenReader(hour.start, hour.end)}`}
              </VisuallyHidden>
              <WeekDay>{day}</WeekDay>
              <Hours isClosed={isClosed}>{HoursToDisplay}</Hours>
            </Row>
          );
        })}
    </HoursList>
  );
};

ClinicHoursList.propTypes = {
  hours: PropTypes.array.isRequired,
};

export default ClinicHoursList;
